import React, { useEffect, useRef } from 'react';
import { Container } from '@pixi/react';
import { slotSpineKey } from '../../../../../core/constants/symbolsNames';
import { Spine } from '../../../../../core/classes/spine';

function JackpotStars() {
  const ref = useRef();

  useEffect(() => {
    if (ref.current) {
      const spine = new Spine({ key: slotSpineKey.jackpotBackGroundStars });
      ref.current.addChild(spine);
    }
  }, []);

  return <Container x={270} y={423} ref={ref} name='JackpotBackGroundStars' />;
}
export default JackpotStars;
